import { useRef } from 'react';
import type { SportFilter } from '../../api/keys';
import { useActivities, useStravaStatus, useThresholds } from '../../api/queries';
import { Eyebrow } from '../../components/Eyebrow';
import { Headline } from '../../components/Headline';
import { Presence } from '../../ui/Presence';
import { useOnTransition } from '../../ui/useOnTransition';
import { UploadPanel } from '../upload/UploadPanel';
import { countsEyebrow } from './activitiesModel';
import { ActivityTable } from './ActivityTable';
import { AddActivityMenu } from './AddActivityMenu';
import { SportFilterTabs } from './SportFilterTabs';
import styles from './activities.module.css';

export function ActivitiesPage({ sport, uploadOpen }: { sport: SportFilter; uploadOpen: boolean }) {
  const query = useActivities(sport);
  const strava = useStravaStatus();
  const thresholds = useThresholds();
  const addButton = useRef<HTMLButtonElement>(null);
  // The menu item that opened the panel is gone by the time it closes, so the modal's own opener restore has nothing to focus.
  useOnTransition(uploadOpen, (wasOpen) => { if (wasOpen) addButton.current?.focus(); });
  const recalcFrom = thresholds.data?.recalculating?.fromDate ?? null;
  const items = query.data?.pages.flatMap((page) => page.items) ?? [];
  return (
    <div className={`page ${styles.page}`}>
      <header className={styles.header}>
        <div className="page-heading">
          <Eyebrow>{countsEyebrow(query.data?.pages[0])}</Eyebrow>
          <Headline first="EVERY" second="SESSION." size="compact" />
        </div>
        <div className={styles.headerRight}>
          <span className={styles.sticker}>NO POWER, PACE OR HR = NO LOAD</span>
          <div className={styles.controls}>
            <SportFilterTabs sport={sport} />
            <AddActivityMenu sport={sport} strava={strava.data} buttonRef={addButton} />
          </div>
        </div>
      </header>
      <ActivityTable query={query} items={items} sport={sport} recalcFrom={recalcFrom} />
      <Presence show={uploadOpen}><UploadPanel sport={sport} /></Presence>
    </div>
  );
}
